var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverLicenseUploded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ic_Driver_license_uploded",
    "data-name": "Ic_Driver license_uploded",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.784,
    height: 17.119,
    viewBox: "0 0 13.784 17.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M202.844,304.637H189.06v-1.844a6,6,0,0,1,6-6h1.794a6,6,0,0,1,6,6Z",
    transform: "translate(-189.06 -287.518)",
    fill: "#3957af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M254.32,88.639a4.285,4.285,0,1,1,3.024-1.254,4.28,4.28,0,0,1-3.024,1.254Z",
    transform: "translate(-247.428 -80.078)",
    fill: "#3957af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverLicenseUploded);
export default __webpack_public_path__ + "static/media/driver_license_uploded.3023319d3c3510ec5972144cc299af99.svg";
export { ForwardRef as ReactComponent };